module.exports = function() {
  return new Worker(__webpack_public_path__ + "f0db4e2e8ae114928d7c.worker.js");
};